import React, { Component } from 'react';
import Routes from "./Routes";
import "./App.css";
import { Helmet, HelmetProvider } from 'react-helmet-async';

class App extends Component {
    render() {
        return (
            <HelmetProvider>
                <>
                    <Helmet>
                        {/* Default charset and viewport */}
                        <meta charSet="utf-8" />
                        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
                        
                        {/* Default language */}
                        <html lang="en" />
                    </Helmet>
                    <Routes />
                </>
            </HelmetProvider>
        );
    }
}

export default App;
